<div class="videoPlayerWrapper">
  <h2>{{pageTitle}}</h2>
  <p>{{pageCopy}}</p>
  <div style='padding:56.25% 0 0 0;position:relative;'><iframe [src]="videoUrl | sanitize: 'resourceUrl'" allowfullscreen frameborder='0' style='position:absolute;top:0;left:0;width:100%;height:100%;'></iframe></div>
</div>
